import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestAddPersonalDate (action) {
  const { timestamp, name, cardId } = action.payload

  yield call(apiAction, 'AddPersonalDate', {
    cardId,
    timestamp,
    name
  })
}
